import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store.js";
import { IntegrationsStore } from "../../../../../svelte/api-stores/integrations-store";

let INTEGRATIONS = {};

const setSyncAsVisibilities = (provider, syncAs) => {
  $(`#${provider}adBtn, #${provider}adBtnInfo`).toggle(
    !["none", ""].includes(syncAs),
  );

  $(`#${provider}Div select, #${provider}Div .freetext-override`).each(
    (_, el) => {
      const kind = $(el).attr("data-kind");
      if (kind === "syncAs") return;

      const providerOverrides = INTEGRATIONS[provider].overrides || {};
      const providerFreetextOverrides =
        INTEGRATIONS[provider].freetextOverrides || {};

      const id = $(el).attr("id");
      const optionValue =
        providerOverrides[kind] || providerFreetextOverrides[kind];

      if (optionValue.syncAsTitles) {
        $(`#${id}-label`).text(
          optionValue.syncAsTitles[syncAs] || optionValue.title,
        );
      }
      if (optionValue.syncAsRestrictions) {
        $(`#${id}-row`).toggle(optionValue.syncAsRestrictions.includes(syncAs));
      }
    },
  );
};

const addCrmOption = (
  provider,
  title,
  label,
  kind,
  opts,
  placeholder,
  options = {},
) => {
  const liveSearch =
    Object.keys(opts).length > 10 ? 'data-live-search="true"' : "";

  let icons = "";
  if (options.adBtn) {
    icons = `
      <i class="fas fa-info-circle" style="cursor: pointer;" id="${provider}adBtnInfo"></i>
      <i class="ml-2 fas fa-arrow-circle-down" style="cursor: pointer;" id="${provider}adBtn"></i>
      `;
  }
  const multi = kind === "syncAs" || options.singleChoice ? "" : "multiple";

  const actionsBox = multi && Object.keys(opts).length > 10 ? "true" : "false";

  const id = `${provider}${kind}Select`;

  const html = `
      <div class="row my-3" id="${id}-row">
        <div class="col d-inline-flex align-items-center">
          <div class="input-group w-auto mr-3">
            <div class="input-group-prepend">
              <span class="input-group-text" style="white-space: break-spaces" id="${id}-label">${label}</span>
            </div>
            <select
              id="${id}"
              data-provider="${provider}"
              data-text-title="${title}"
              data-kind="${kind}"
              class="selectpicker form-control"
              title="${placeholder}"
              ${multi}
              ${liveSearch}
              data-actions-box="${actionsBox}"
              data-size="10"
            >
            </select>
          </div>
          ${icons}
        </div>
      </div>`;

  const selector = options.isAd ? `#${provider}AdDiv` : `#${provider}Div`;
  $(selector).append(html);

  $(`#${provider}adBtnInfo`).tooltip("dispose").tooltip({
    title:
      "If the advanced CRM option applies to everybody in the spreadsheet, set it here. If different options apply to different contacts, then map a column in the spreadsheet to the relevant CRM variable instead.",
  });
  $(`#${provider}adBtn`)
    .tooltip("dispose")
    .tooltip({ title: "Advanced Options" });

  Object.entries(opts).forEach(([text, value]) => {
    $(`#${provider}${kind}Select`).append($("<option>", { value, text }));
  });

  $(`#${provider}${kind}Select`).selectpicker("refresh");
};

const addCrmInputOption = (provider, value, kind) => {
  const id = `${provider}${kind}Input`;

  const html = `
      <div class="row my-2" id="${id}-row">
        <div class="col d-flex align-items-center">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" style="white-space: break-spaces" id="${id}-label">${value.title}</span>
            </div>
            <div style="width: 25rem">
              <textarea
                id="${id}"
                class="form-control freetext-override"
                data-provider="${provider}"
                data-text-title="${value.title}"
                data-kind="${kind}"
                style="font-size: revert; height: 100%; border-top-left-radius: 0; border-bottom-left-radius: 0;"
              ></textarea>
            </div>
          </div>
        </div>
      </div>`;

  $(`#${provider}AdDiv`).append(html);
};

const createCrmSyncOptions = (res) => {
  Object.entries(res).forEach(([provider, val]) => {
    $("#syncOptionsDiv").append(`<div class="my-2" id="${provider}Div"></div>`);

    if (!val.syncKinds) return;

    const { syncAsLabelMap } = val;

    const syncKinds = val.syncKinds.reduce((ret, syncKind) => {
      if (val.syncKinds.length === 1) ret.Add = syncKind;
      else ret[`Add as ${syncAsLabelMap[syncKind] || syncKind}`] = syncKind;
      return ret;
    }, {});

    syncKinds["Don't Add"] = "none";
    addCrmOption(
      provider,
      val.title,
      val.title,
      "syncAs",
      syncKinds,
      "Choose...",
      { adBtn: !!val.overrides || !!val.freetextOverrides },
    );

    if (val.overrides || val.freetextOverrides) {
      $(`#${provider}Div`).append(`<div id="${provider}AdDiv"></div>`);

      Object.entries(val.overrides || {}).forEach(([k, v]) => {
        const placeholder = v.mandatory ? "Choose..." : "(Optional)";
        addCrmOption(provider, v.title, v.title, k, v.values, placeholder, {
          isAd: true,
          singleChoice: v.singleChoice,
        });
      });

      Object.entries(val.freetextOverrides || {}).forEach(([k, v]) => {
        addCrmInputOption(provider, v, k);
      });

      $(`#${provider}AdDiv`).hide();
      $(`#${provider}adBtn`).click((e) => {
        $(`#${provider}AdDiv`).toggle();
        $(`#${provider}AdDiv .input-group-text`).addClass(
          "input-text-adv-options",
        );
        const hidden = $(`#${provider}AdDiv`).is(":hidden");
        $(e.target)
          .removeClass(`fa-arrow-circle-${hidden ? "up" : "down"}`)
          .addClass(`fa-arrow-circle-${hidden ? "down" : "up"}`);
      });

      $(`#${provider}syncAsSelect`).change((e) => {
        const syncAs = $(e.target).selectpicker("val");
        setSyncAsVisibilities(provider, syncAs);
      });
      setSyncAsVisibilities(
        provider,
        $(`#${provider}syncAsSelect`).selectpicker("val"),
      );
    }
  });
};

export const atsSettingsMaps = () => {
  const ret = {};
  $("#syncOptionsDiv select").each((_, el) => {
    const provider = $(el).attr("data-provider");
    const kind = $(el).attr("data-kind");
    const val = $(el).selectpicker("val");
    if (kind === "syncAs") ret[provider] = { syncAs: val, overrides: {} };
    else ret[provider].overrides[kind] = val;
  });
  $("#syncOptionsDiv textarea").each((_, el) => {
    const provider = $(el).attr("data-provider");
    const kind = $(el).attr("data-kind");
    ret[provider].overrides[kind] = $(el).val();
  });
  return ret;
};
export const initializeIntegrations = () => {
  // Need to wait for the user store to fetch so we know if the user is an admin
  userStore.once().then((user) => {
    // N.B. this is a slightly different integrations store to the one used in Campaign Settings
    IntegrationsStore({ hideLockedSyncKinds: !user.isAdmin })
      .once()
      .then((res) => {
        INTEGRATIONS = res;
        createCrmSyncOptions(res);
      });
  });
};
